import { motion } from "framer-motion";
import { useSite } from "@/lib/useSite";

export default function Testimonials() {
  const { data } = useSite();
  const testimonials = data?.settings?.testimonials || [];
  if (!testimonials.length) return null;

  return (
    <div data-testid="testimonials-block" className="mt-24">
      <div className="border-t border-ink/10">
        {testimonials.map((t, i) => (
          <motion.blockquote
            key={i}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="grid gap-4 border-b border-ink/10 py-10 md:grid-cols-12 md:gap-8"
          >
            <span className="font-mono text-xs tracking-[0.25em] text-srs md:col-span-2">({String(i + 1).padStart(2, "0")})</span>
            <p className="font-display text-2xl font-light leading-snug tracking-tight text-ink sm:text-3xl md:col-span-7">
              &ldquo;{t.text}&rdquo;
            </p>
            <footer className="self-end font-mono text-[11px] uppercase tracking-[0.2em] text-subtle md:col-span-3 md:text-right">
              <span className="text-ink">{t.name}</span>
              {t.location && <span> · {t.location}</span>}
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  );
}
